<template>
    <OrderForm />
</template>
<script>
import OrderForm from "../OrderForm.vue"
export default {
    components:{
        OrderForm
    }
}
</script>